export const ENTER_KEY_CODE = 13;
export const ERROR_WITH_STATUS_CODES_MAP = {
    _400_BadRequest: 400,
    _401_Unauthorized: 401,
    _403_Forbidden: 403,
    _404_NotFound: 404,
    _500_ServerError: 500,
};
